import React, { useState, useContext } from 'react';
import { Container, Row, Col, Button, Form, Spinner, Alert } from 'react-bootstrap';
import axios from "axios";
import $ from 'jquery';
import 'jquery-confirm';
import { AppContext } from '../App';
import { apiRequest } from '../utils/apiHelper';


export const Authentication = () => {
	const { setAccessToken, link, setUser } = useContext(AppContext);
	const [loginError, setLoginError] = useState(false);
	const [load, setLoad] = useState(false);
	const AuthCheck = (token) => {
		apiRequest({
			url: `${link}api/cs/auth/check/`,
			token: token,
			setLoading: setLoad,
			onSuccess: (data) => {
				setUser(data);
				setAccessToken(token);
			},
			onError: (err) => {
				setLoginError(true);
				setTimeout(() => { setLoginError(false) }, 5000);
				setAccessToken();
			}
		});
	}
	const requestUser = (event) => {
		event.preventDefault();
		if (event.target.username.value !== "" && event.target.password.value !== "") {
			setLoad(true);
			apiRequest({
				url: `${link}api/token/`,
				method: 'POST',
				data: {
					username: event.target.username.value,
					password: event.target.password.value,
				},
				onSuccess: (data) => {
					AuthCheck(data.access);
				},
				onError: (err) => {
					setLoad(false);
					setLoginError(true);
					setTimeout(() => { setLoginError(false) }, 5000);
					console.log('Invalid credentials!');
				}
			});
		}
	}


	return (
		<Container className="wrapper" >
			<Row className="login-window br-4" >
				<div className="p-5 grid-center" >
					{
						loginError !== undefined && loginError ? (
							<Alert variant="warning" className="t-red br-3" >Invalid credentials!</Alert>
						) : ''
					}
					<Form onSubmit={requestUser} className="login-form" >
						<Form.Group className="mb-3 text-white">
							<Form.Control type="text" name="username" required className="shadow-none" placeholder="Username" />
						</Form.Group>
						<Form.Group className="mb-3  text-white">
							<Form.Control type="password" name="password" required className="shadow-none" placeholder="Password" />
						</Form.Group>
						<div className="d-grid gap-2">
							{
								load ? (
									<Button variant="outline-primary" disabled>
										<span><Spinner animation="border" size="sm" /> Please wait...</span></Button>
								) : (
									<Button type="submit" className="login-btn" >LOGIN</Button>
								)
							}
						</div>
					</Form>
				</div>
			</Row>
		</Container>
	);
}